import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, ButtonModel, Text } from '@notino/react-styleguide';

import messages from '../../../../../../messages';

import { noReviewMessages } from './messages';
import { NoReviewsIcon } from './NoReviewsIcon';
import { NoReviewsDescription, NoReviewWrapper } from './styled';

interface INoReviewsProps {
  onWriteMessageClick: () => void;
}

export const NoReviews: React.FC<INoReviewsProps> = ({
  onWriteMessageClick,
}) => {
  return (
    <NoReviewWrapper>
      <NoReviewsDescription>
        <NoReviewsIcon />

        <Text typography="titleMedium" color="text.primary">
          <FormattedMessage {...noReviewMessages.noReview} />
        </Text>

        <Text typography="labelRegular400" color="text.secondary">
          <FormattedMessage {...noReviewMessages.noReviewSubtitle} />
        </Text>
      </NoReviewsDescription>

      <Button
        data-cypress="reviews-addNewReview"
        buttonStyle={ButtonModel.Styles.secondary}
        onClick={onWriteMessageClick}
      >
        <FormattedMessage {...messages.writeReview} />
      </Button>
    </NoReviewWrapper>
  );
};
